//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SiteFileDrawer from "./modules/SiteFileDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api'; // 站点树展示

import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'SiteFileList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    SiteFileDrawer: SiteFileDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/site/file',
      pageTitle: '报备文件',
      autoLoadInit: false,
      isorter: {
        column: 'file_date',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '运维人员',
        align: 'center'
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '报备类型',
        align: 'center'
      }, {
        dataIndex: 'fileDate',
        colName: 'file_date',
        title: '报备时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'title',
        colName: 'title',
        title: '标题',
        align: 'center'
      }, {
        dataIndex: 'nextStatus',
        colName: 'nextStatus',
        title: '当前审批状态',
        align: 'center',
        scopedSlots: {
          customRender: 'nextStatus'
        }
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      userTree: [] //人员信息

    };
  },
  created: function created() {
    this.queryParam.scopeId = this.scopeId;
    this.queryParam.scope = this.scope;
    this.queryParam.category = this.category;
    this.queryParam.status = 1;

    if (this.scope == 1) {
      // 根据站点id
      this.spliceColumn(this.siteColumn);
    } else {
      // 根据区域id
      this.spliceColumn(this.siteColumn, 1);
    } // this.loadData()


    this.loadTreeList();
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    onDateFileDate: function onDateFileDate(value, dateArray) {
      this.queryParam.fileDateStart = dateArray[0];
      this.queryParam.fileDateEnd = dateArray[1];
    }
  }
};